module.exports = __webpack_public_path__ + "img/home.287cab81.png";